import toast from 'react-hot-toast';

// Custom toast styles matching the design system
const toastOptions = {
  duration: 4000,
  style: {
    borderRadius: '12px',
    padding: '16px',
    fontSize: '14px',
    fontWeight: '500',
  },
  success: {
    iconTheme: {
      primary: '#10b981',
      secondary: '#fff',
    },
    style: {
      border: '1px solid #10b981',
      backgroundColor: '#f0fdf4',
      color: '#166534',
    },
  },
  error: {
    iconTheme: {
      primary: '#ef4444',
      secondary: '#fff',
    },
    style: {
      border: '1px solid #ef4444',
      backgroundColor: '#fef2f2',
      color: '#991b1b',
    },
  },
  loading: {
    iconTheme: {
      primary: '#3b82f6',
      secondary: '#fff',
    },
    style: {
      border: '1px solid #3b82f6',
      backgroundColor: '#eff6ff',
      color: '#1e40af',
    },
  },
};

// Toast utility functions
export const showToast = {
  success: (message: string, options?: any) => {
    return toast.success(message, {
      ...toastOptions,
      ...toastOptions.success,
      ...options,
    });
  },

  error: (message: string, options?: any) => {
    return toast.error(message, {
      ...toastOptions,
      ...toastOptions.error,
      ...options,
    });
  },

  loading: (message: string, options?: any) => {
    return toast.loading(message, {
      ...toastOptions,
      ...toastOptions.loading,
      ...options,
    });
  },

  promise: <T,>(
    promise: Promise<T>,
    messages: {
      loading: string;
      success: string | ((data: T) => string);
      error: string | ((error: any) => string);
    },
    options?: any
  ) => {
    return toast.promise(
      promise,
      messages,
      {
        ...toastOptions,
        success: { ...toastOptions.success, ...options?.success },
        error: { ...toastOptions.error, ...options?.error },
        loading: { ...toastOptions.loading, ...options?.loading },
      }
    );
  },

  custom: (message: string, options?: any) => {
    return toast(message, {
      ...toastOptions,
      ...options,
    });
  },

  dismiss: (toastId?: string) => {
    toast.dismiss(toastId);
  },

  remove: (toastId?: string) => {
    toast.remove(toastId);
  },
};

export default showToast;
